import {cartReducer}  from "../reducers/SelectedProductReducer";

export const addProductsToCart = (items) => async (dispatch) => {
  console.log(items)
    dispatch(cartReducer(items));
};
  

export const emptyCart = () => async (dispatch) => {
  dispatch(cartReducer([]));
};